export const oneMs = 1000

export const MEMBERSHIP_STORE_KEY = 'app-space:membership'
